import { useState, useContext, useEffect, useMemo } from 'react'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import logoTextColourSource from '/components/editor/logo-text-colour-source'

const Logo = () => {

  const { passType, model, template, variables } = useContext(PassContext)

  // We need to set a size for the text box in order to 
  // be able to truncate it. But we do not know how much
  // space we have for text until we [optionally] load the logo image

  const [textWidth, setTextWidth] = useState(200)
  const [imageWidth, setImageWidth] = useState(50)
  const [imageSrc, setImageSrc] = useState(null)

  const logoPath = "meta.images.logo"
  const logoSrcUrl = dataSelector({ template, variables, path: logoPath })

  const titlePath = "meta.title"
  const titleValue = dataSelector({ template, variables, path: titlePath })


  const imageLoaded = e => {
    const img = e.target
    const displayedImageWidth = (50 / img.height) * img.width
    setImageWidth(displayedImageWidth)
    setTextWidth(250 - displayedImageWidth)
  }

  const titleColor = useMemo(() => logoTextColor({ passType, model, variables }), [model,variables])

  useEffect(() => {
    if (!logoSrcUrl) return
    const img = new Image()
    img.crossOrigin = "anonymous"          // important for canvas/color picking
    img.onload = () => {
      setImageSrc(logoSrcUrl)
    }
    img.onerror = () => setImageSrc(null)
    img.src = logoSrcUrl                   // set after crossOrigin
  }, [logoSrcUrl])

  return (
    <div className="logo flex flex-row w-full justify-between items-center" style={{ width: 200 }}>
      <PopupEditor title="Logo Image" path="meta.images.logo">
        <div className="image" style={{ position: "relative" }}>
          <div style={{ position: "absolute", height: 50, width: imageWidth }} className="editable" />
          <img src={imageSrc} style={{ width: imageWidth }} onLoad={e => imageLoaded(e)} crossOrigin="anonymous" />
        </div>
      </PopupEditor>

      <PopupEditor title="Title Text" path="meta.title" colors={{ title: titleColor.path }} variable="pass.title">
        <div className="text editable" style={{ width: textWidth, color: titleColor.colour }}>
          {titleValue}
        </div>
      </PopupEditor>
    </div>
  )
}

export default Logo


const logoTextColor = ({ passType, model, variables }) => {

  if (passType === "eventTicket") {
    const bgImage = dataSelector({ template:model, variables, path: "meta.images.background" })

    if (bgImage) {
      const colour = dataSelector({ template:model, variables, path:"labelColor" })
      return { path:"model.labelColor", colour } // Undocumented, but event tickets with background image use label rather than foreground colour
    }
  }
  // Another undocumented feature - the colour souce also depends on the background colour... either foregoundColor or labelColor
  const colourSource = logoTextColourSource({ variables })
  const colour = dataSelector({ template:model, variables, path:colourSource })
  return { path:"model." + colourSource, colour }
}

